import { useState, useEffect } from 'react'

/**
 * Drives the 3-phase loading-copy advance on the `generating` step.
 *
 * Returns 0 | 1 | 2. Self-resets to 0 when the step exits
 * `generating`. Two setTimeouts (1200ms, 3000ms) clean up on
 * unmount + step transition.
 *
 * Purely cosmetic; not tied to any backend pipeline event.
 */
export default function useLoadingPhase (step: string): 0 | 1 | 2 {
  const [loadingPhase, setLoadingPhase] = useState<0 | 1 | 2>(0)
  useEffect(() => {
    if (step !== 'generating') return undefined
    setLoadingPhase(0)
    const t1 = setTimeout(() => setLoadingPhase(1), 1200)
    const t2 = setTimeout(() => setLoadingPhase(2), 3000)
    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [step])
  return loadingPhase
}
